// extracted by mini-css-extract-plugin
module.exports = {"session-details":"session-details__session-details___1mh63","icon-container":"session-details__icon-container___1Jz0g"};